import axios from 'axios'
import getConfig from '../config'
const { API_BASE_URI } = getConfig()

const EXCLUDED_FIELDS = {
  id: 1,
  createdAt: 1,
  updatedAt: 1
}

export async function getPage (pageId, params) {
  const response = await axios({
    method: 'get',
    url: `${API_BASE_URI}/pages/${pageId}`,
    params
  })
  return response.data
}

export async function updatePage (pageId, data) {
  const copy = {}
  for (let key in data) {
    if (key in EXCLUDED_FIELDS) { continue }
    copy[key] = data[key]
  }
  const response = await axios({
    method: 'put',
    url: `${API_BASE_URI}/pages/${pageId}`,
    data: data
  })
  return response.data
}

export async function updatePages (pages) {
  const response = await axios({
    method: 'put',
    url: `${API_BASE_URI}/pages`,
    data: pages
  })
  return response.data
}

export async function createPage (data) {
  const copy = {}
  for (let key in data) {
    if (key in EXCLUDED_FIELDS) { continue }
    copy[key] = data[key]
  }
  const response = await axios({
    method: 'post',
    url: `${API_BASE_URI}/pages`,
    data: data
  })
  return response.data
}

export async function listPages ({offset, limit, filters, sort}) {
  let url = `${API_BASE_URI}/pages?offset=${offset}&limit=${limit}`
  url += sort ? `&sort=${sort}` : ''
  for (var key in filters) {
    url += `&${key}=${filters[key]}`
  }
  const response = await axios({
    method: 'get',
    url: url
  })
  return response.data
}

export async function listChildPages (parentId, offset, limit) {
  const response = await axios({
    method: 'get',
    url: `${API_BASE_URI}/pages?parentId=${parentId}&offset=${offset}&limit=${limit}`
  })
  return response.data
}

export async function deletePage (pageId) {
  const response = await axios({
    method: 'delete',
    url: `${API_BASE_URI}/pages/${pageId}`
  })
  return response.data
}

export async function deleteDraft (pageId) {
  const response = await axios({
    method: 'delete',
    url: `${API_BASE_URI}/pages/${pageId}/draft`
  })
  return response.data
}

export async function unpublishPage (pageId) {
  const response = await axios({
    method: 'post',
    url: `${API_BASE_URI}/pages/${pageId}/unpublish`,
    data: {}
  })
  return response.data
}

export async function publishPage (pageId) {
  const response = await axios({
    method: 'post',
    url: `${API_BASE_URI}/pages/${pageId}/publish`,
    data: {}
  })
  return response.data
}



// WEBPACK FOOTER //
// ./src/api/pages.js